import { LuckyDrawEventType, IPaginationResponseDto, ILuckyDraw, ILuckyDrawCreator, IApiResult } from '../types';
import { AxiosResponse, Canceler } from 'axios';
import settings from '../settings';
import moment from 'moment-timezone';
import api from './base';

export function getLuckyDraws(eventTypes: LuckyDrawEventType[]): [Promise<AxiosResponse<IPaginationResponseDto<ILuckyDraw>>>, Canceler] {
  const uri = `${settings.getApiURI()}/event/v1/lucky-draws`;
  const params = { eventTypes };

  return api.getWithCancel(uri, { params });
}

export function getLuckyDraw(luckyDrawId: number): [Promise<AxiosResponse<ILuckyDraw>>, Canceler] {
  const uri = `${settings.getApiURI()}/event/v1/lucky-draws/${luckyDrawId}`;

  return api.getWithCancel(uri);
}

export function saveLuckyDraw(payload: Partial<ILuckyDrawCreator>): Promise<AxiosResponse<IApiResult<ILuckyDraw>>> {
  const uri = `${settings.getApiURI()}/event/v1/lucky-draws`;
  return api.http.post(uri, payload);
}

export function deactiveLuckyDraw(luckyDrawId: number): Promise<AxiosResponse<IApiResult<ILuckyDraw>>> {
  const uri = `${settings.getApiURI()}/event/v1/lucky-draws/${luckyDrawId}`;
  return api.http.put(uri, { expiredAt: moment().toISOString() });
}

export function deleteLuckyDraw(luckyDrawId: number): Promise<AxiosResponse<IApiResult<ILuckyDraw>>> {
  const uri = `${settings.getApiURI()}/event/v1/lucky-draws/${luckyDrawId}`;
  return api.http.delete(uri);
}
